import api from "./api";

// لیست درخواست‌ها
export const getUserRequests = async () => {
  const res = await api.get("/user-panel/credit-requests");
  return res.data;
};

/*
// تایید درخواست
export const approveRequest = async (id) => {
  const res = await api.post(`/user-panel/credit-requests/${id}/approve`);
  return res.data;
};

// رد درخواست
export const rejectRequest = async (id) => {
  const res = await api.post(`/user-panel/credit-requests/${id}/reject`);
  return res.data;
};
*/

// موجودی
export const getUserBalance = async () => {
  const res = await api.get("/user-panel/balance");
  return res.data;
};

// لیست فروشگاه ها
export const getUserStores = async () => {
  const res = await api.get("/user-panel/stores");
  return res.data;
};
